module.exports = __webpack_public_path__ + "static/branding-2c969631e44c6b04fd843c4e88e8a609.png";